<template>
    <div v-if="languages && !loading && Object.keys(languages).length >= 1"
         class="languageSelector"
         :class="{
            'languageSelector--solo': Object.keys(languages).length === 1
         }"
    >
        <button class="languageSelector__button"
                @click="toggleState"
                :keyup.enter="toggleState"
        >
            <span class="languageSelector__buttonCode">
                {{ selected_language.code === "en" ? "uk" : selected_language.code }}
            </span>

            <span v-if="Object.keys(languages).length >= 1" class="languageSelector__buttonIndicator">
                <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.05584 0.967893C8.05584 1.14079 7.9838 1.32809 7.83972 1.45777L4.84284 4.23852C4.56909 4.49787 4.19448 4.51227 3.92073 4.26734L0.88063 1.44336C0.635693 1.21283 0.606877 0.794997 0.851813 0.521244C1.09675 0.261898 1.51458 0.24749 1.77393 0.492427L4.36738 2.91298L6.96083 0.492427C7.37866 0.117818 8.05584 0.391571 8.05584 0.967893Z" fill="white"/>
                </svg>
            </span>
        </button>

        <div class="languageSelector__dropdown" v-if="open">
            <div class="languageSelector__dropdownLanguage" v-for="language in languages">
                <a :href="language.url">
                    <svg v-if="language.code === 'en'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" width="40" height="26" >
                        <clipPath id="t">
                            <path d="M25,15h25v15zv15h-25zh-25v-15zv-15h25z"/>
                        </clipPath>
                        <path d="M0,0v30h50v-30z" fill="#012169"/>
                        <path d="M0,0 50,30M50,0 0,30" stroke="#fff" stroke-width="6"/>
                        <path d="M0,0 50,30M50,0 0,30" clip-path="url(#t)" stroke="#C8102E" stroke-width="4"/>
                        <path d="M-1 11h22v-12h8v12h22v8h-22v12h-8v-12h-22z" fill="#C8102E" stroke="#FFF" stroke-width="2"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="26" viewBox="0 0 90 60">
                        <path fill="#e03c31" d="m0 0h90v30H45z"/>
                        <path fill="#001489" d="m0 60h90V30H45z"/>
                        <g fill="none">
                            <path stroke="#fff" stroke-width="20" d="m90 30H45L0 0v60l45-30"/>
                            <path fill="#000" stroke="#ffb81c" stroke-width="15" d="m-5 0 45 30L-5 60"/>
                            <path stroke="#007749" stroke-width="12" d="m0 0 45 30h45M0 60l45-30"/>
                        </g>
                    </svg></a>
            </div>
        </div> <!-- .languageDropdown -->
    </div> <!-- .languageSelectorWrap -->

    <div class="languageSelector" v-else>
        <button class="languageSelector__button" @click.prevent>
            <span class="languageSelector__buttonCode">...</span>
        </button>
    </div> <!-- .languageSelectorWrap -->
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            open: false,
            languages: mtc_language.languages,
        }
    },
    mounted() {
        this.loading = false
    },
    methods: {
        toggleState() {
            if (Object.keys(this.languages).length >= 2) this.open = !this.open
        }
    },
    computed: {
        selected_language() {
            if (this.languages) {
                for (const [code, language] of Object.entries(this.languages)) {
                    if (language.active === '1') {
                        return language
                    }
                }
            }
        }
    }
}
</script>
